<ng-template #loader>
  <boma-anim-spinning-loader [size]="80"></boma-anim-spinning-loader>
</ng-template>
<div class="card p-mt-4" *ngIf="userEntity$ | async; else loader">
  <p-tabView (onChange)="handleTabChange($event)">
    <p-tabPanel header="Details">
      <form
        (ngSubmit)="onSubmitUpdateDetails()"
        [formGroup]="updateFormGroup"
        class="pb-2"
      >
        <div class="field grid">
          <label
            class="p-col-fixed"
            for="identificationNumber"
            style="width: 200px"
            >Identification Number</label
          >
          <div class="col">
            <input
              [ngStyle]="{ width: '100%' }"
              formControlName="identificationNumber"
              id="identificationNumber"
              pInputText
              type="text"
            />
          </div>
        </div>

        <div class="field grid">
          <label class="p-col-fixed" for="employeeNumber" style="width: 200px"
            >Employee Number</label
          >
          <div class="col">
            <input
              [ngStyle]="{ width: '100%' }"
              formControlName="employeeNumber"
              id="employeeNumber"
              pInputText
              type="text"
            />
          </div>
        </div>

        <div class="field grid">
          <label class="p-col-fixed" for="position" style="width: 200px"
            >Position</label
          >
          <div class="col">
            <input
              [ngStyle]="{ width: '100%' }"
              formControlName="position"
              id="position"
              pInputText
              type="text"
            />
          </div>
        </div>

        <div class="field grid">
          <label
            class="p-col-fixed"
            for="companyContactNumber"
            style="width: 200px"
            >Company Contact No.</label
          >
          <div class="col">
            <input
              [ngStyle]="{ width: '100%' }"
              formControlName="companyContactNumber"
              id="companyContactNumber"
              pInputText
              type="text"
            />
          </div>
        </div>

        <div class="field grid">
          <label
            class="p-col-fixed"
            for="personalContactNumber"
            style="width: 200px"
            >Personal Contact No.</label
          >
          <div class="col">
            <input
              [ngStyle]="{ width: '100%' }"
              formControlName="personalContactNumber"
              id="personalContactNumber"
              pInputText
              type="text"
            />
          </div>
        </div>

        <div class="field grid">
          <label class="p-col-fixed" for="department" style="width: 200px"
            >Department</label
          >
          <div class="col">
            <input
              [ngStyle]="{ width: '100%' }"
              formControlName="department"
              id="department"
              pInputText
              type="text"
            />
          </div>
        </div>

        <div class="field grid">
          <label class="p-col-fixed" for="notes" style="width: 200px"
            >Notes</label
          >
          <div class="col">
            <textarea
              [ngStyle]="{ width: '100%' }"
              formControlName="notes"
              id="notes"
              pInputText
              rows="4"
              type="text"
            ></textarea>
          </div>
        </div>

        <p-button
          *ngIf="loading$ | async"
          [disabled]="updateFormGroup.pristine"
          icon="pi pi-save"
          label="Save Changes"
          styleClass="p-button-success p-float-right"
          type="submit"
        ></p-button>
      </form>
    </p-tabPanel>

    <p-tabPanel header="Permissions">
      <ng-container
        *ngIf="
          locationRoleOptions$ && vehicleRoleOptions$ && entityRoleOptions$;
          else loader
        "
      >
        <div class="flex justify-content-between my-5">
          <div>
            <p-button
              (click)="onSubmitUpdatePermissions()"
              [loading]="loading$ | async"
              icon="pi pi-save"
              label="Save Changes"
              styleClass="p-button-success"
            ></p-button>
          </div>
        </div>

        <div class="grid justify-content-center">
          <div class="col md:col-4">
            <h5>Global (Custom Roles)</h5>
            <div class="flex flex-wrap">
              <p-checkbox
                *ngFor="let role of assignedCustomAdminRoles"
                [(ngModel)]="role.assigned"
                [disabled]="
                  (loggedInUser$ | async) !== null
                    ? role.title === 'Owner' &&
                      userId === (loggedInUser$ | async).id
                    : false
                "
                binary="true"
                class="block mr-4 mb-2"
                label="{{ role.title }}"
                name="entityRoles"
                value="{{ role.id }}"
              >
              </p-checkbox>
            </div>

            <h5>Global (Boma Preset Roles)</h5>
            <hr />
            <div class="flex flex-wrap">
              <p-checkbox
                *ngFor="let role of assignedAdminRolesDiff"
                [(ngModel)]="role.assigned"
                [disabled]="
                  (loggedInUser$ | async) !== null
                    ? role.title === 'Owner' &&
                      userId === (loggedInUser$ | async).id
                    : false
                "
                binary="true"
                class="block mr-4 mb-2"
                label="{{ role.title }}"
                name="entityRoles"
                value="{{ role.id }}"
              >
              </p-checkbox>
            </div>
          </div>
          <div class="col md:col-4">
            <!-- <boma-location-search (locationSelectedChange)='locations'> -->
            <!-- </boma-location-search> -->
            <p-table
              [value]="assignedLocationRolesDiff"
              #dt1
              dataKey="id"
              [globalFilterFields]="['title']"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th>
                    <div class="flex align-items-center">
                      Location Permissions

                      <span class="p-input-icon-left ml-auto">
                        <i class="pi pi-search"></i>
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt1.filterGlobal($event.target.value, 'contains')
                          "
                          placeholder="Filter location"
                        />
                        <p-columnFilter
                          type="text"
                          field="title"
                          display="menu"
                        ></p-columnFilter>
                      </span>

                      <!-- <button
                        (click)="loadLocations()"
                        class="p-button-text ml-auto p-button-outlined"
                        icon="pi pi-refresh"
                        pButton
                        pRipple
                      ></button> -->
                    </div>
                  </th>
                </tr>
                <tr>
                  <th class="flex align-items-center">
                    Show Only Locations with Permissions
                    <p-checkbox
                      class="ml-2"
                      [ngModel]="isFiltered"
                      [binary]="true"
                      (click)="toggleEmptyState()"
                    ></p-checkbox>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-location>
                <tr>
                  <td>
                    <h5>{{ location.title }}</h5>
                    <div class="flex flex-wrap">
                      <p-checkbox
                        *ngFor="let locationRole of location.roles"
                        [(ngModel)]="locationRole.assigned"
                        [label]="locationRole.title"
                        binary="true"
                        class="block mr-4 mb-2"
                      >
                      </p-checkbox>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>

          <div class="col md:col-4">
            <p-table
              [value]="assignedVehicleRolesDiff"
              #dt2
              dataKey="id"
              [globalFilterFields]="['title']"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th>
                    <div class="flex align-items-center">
                      Vehicle Permissions

                      <span class="p-input-icon-left ml-auto">
                        <i class="pi pi-search"></i>
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt2.filterGlobal($event.target.value, 'contains')
                          "
                          placeholder="Filter vehicles"
                        />
                        <p-columnFilter
                          type="text"
                          field="title"
                          display="menu"
                        ></p-columnFilter>
                      </span>
                    </div>
                  </th>
                </tr>
                <tr>
                  <th class="flex align-items-center">
                    Show Only Locations with Permissions
                    <p-checkbox
                      class="ml-2"
                      [ngModel]="isFilteredVehicles"
                      [binary]="true"
                      (click)="toggleVehicleEmptyState()"
                    ></p-checkbox>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-location>
                <tr>
                  <td>
                    <h5>{{ location.title }}</h5>
                    <div class="flex flex-wrap">
                      <p-checkbox
                        *ngFor="let locationRole of location.roles"
                        [(ngModel)]="locationRole.assigned"
                        [label]="locationRole.title"
                        binary="true"
                        class="block mr-4 mb-2"
                      >
                      </p-checkbox>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </ng-container>
    </p-tabPanel>
  </p-tabView>
</div>
